export enum GroupType {
    iamImpact = 'iamImpact',
    networkAccess = 'networkAccess',
    category = 'category',
}
